import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@context/AuthContext';

// Layouts
import Layout from '@components/common/Layout';

// Pages
import LoginPage from '@pages/LoginPage';
import ForgotPasswordPage from '@pages/ForgotPasswordPage';
import DashboardPage from '@pages/DashboardPage';
import TicketsPage from '@pages/TicketsPage';
import CreateTicketPage from '@pages/CreateTicketPage';
import TicketDetailsPage from '@pages/TicketDetailsPage';
import TicketEditPage from '@pages/TicketEditPage';
import AnalyticsPage from '@pages/AnalyticsPage';
import UsersPage from '@pages/UsersPage';
import SettingsPage from '@pages/SettingsPage';
import ProfilePage from '@pages/ProfilePage';
import NotFoundPage from '@pages/NotFoundPage';

// Components
import ProtectedRoute from '@components/common/ProtectedRoute';
import Loading from '@components/common/Loading';

const AppRoutes = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className='min-h-screen flex items-center justify-center'>
        <Loading size='lg' />
      </div>
    );
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path='/login'
        element={user ? <Navigate to='/dashboard' replace /> : <LoginPage />}
      />
      <Route
        path="/forgot-password"
        element={user ? <Navigate to="/dashboard" replace /> : <ForgotPasswordPage />}
      />

      {/* Protected Routes */}
      <Route
        path='/'
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        {/* Default redirect to dashboard */}
        <Route index element={<Navigate to='/dashboard' replace />} />

        {/* Dashboard */}
        <Route path='dashboard' element={<DashboardPage />} />

        {/* Tickets */}
        <Route path='tickets' element={<TicketsPage />} />
        <Route path='tickets/create' element={<CreateTicketPage />} />
        <Route path='tickets/:id' element={<TicketDetailsPage />} />
        <Route path='tickets/:id/edit' element={<TicketEditPage />} />

        {/* Analytics */}
        <Route path='analytics' element={<AnalyticsPage />} />

        {/* Users - Admin only */}
        <Route
          path='users'
          element={
            <ProtectedRoute requiredRole='admin'>
              <UsersPage />
            </ProtectedRoute>
          }
        />

        {/* Settings - Admin only */}
        <Route
          path='settings'
          element={
            <ProtectedRoute requiredRole='admin'>
              <SettingsPage />
            </ProtectedRoute>
          }
        />

        {/* Profile */}
        <Route path='profile' element={<ProfilePage />} />
      </Route>

      {/* Catch all route */}
      <Route path='*' element={<NotFoundPage />} />
    </Routes>
  );
};

export default AppRoutes;
